
export interface NotificationStatus {
  isRead: boolean;
}
